import { Navigate, Route, Routes } from 'react-router-dom';
import CheckoutTickets from './CheckoutTickets';
import CheckoutPayment from './CheckoutPayment';
import CheckoutLogin from './CheckoutLogin';
import CheckoutPaymentMethods from './CheckoutPaymentMethods';
import CheckoutAddCard from './CheckoutAddCard';
import { CheckoutPix } from './Pix';
import CheckoutSuccess from './CheckoutSuccess';
import { CheckoutPixSuccess } from './Pix/CheckoutPixSuccess';
import { CheckoutPixRejected } from './Pix/CheckoutPixRejected';
import CheckoutRejected from './CheckoutRejected';
import CheckoutError from './CheckoutError';
import CheckoutOpenError from './CheckoutOpenError';
import CheckoutConfirmCard from './CheckoutConfirmCard';
import { CheckoutLayout } from './Layout';

export const CheckoutRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<CheckoutLayout />}>
        <Route path="/success" element={<CheckoutSuccess />} />
        <Route path="/pix-success" element={<CheckoutPixSuccess />} />
        <Route path="/pix-rejected" element={<CheckoutPixRejected />} />
        <Route path="/rejected" element={<CheckoutRejected />} />
        <Route path="/error" element={<CheckoutError />} />
        <Route path="/open-error" element={<CheckoutOpenError />} />

        <Route path="/tickets" element={<CheckoutTickets />} />
        <Route path="/payment" element={<CheckoutPayment />} />
        <Route path="/login" element={<CheckoutLogin />} />

        <Route path="/payment-methods" element={<CheckoutPaymentMethods />} />
        <Route path="/add-card" element={<CheckoutAddCard />} />
        <Route path="/pix" element={<CheckoutPix />} />

        <Route
          path="/confirm-card/:paymentMethodId"
          element={<CheckoutConfirmCard />}
        />

        <Route path="*" element={<Navigate to="tickets" />} />
      </Route>
    </Routes>
  );
};
